(function () {
  window.__artistListProcessedRoots = window.__artistListProcessedRoots || [];

  function listRootForConfig(cfgEl) {
    var sib = cfgEl.nextElementSibling;
    while (sib) {
      if (sib.matches && sib.matches('[data-artist-list]')) return sib;
      sib = sib.nextElementSibling;
    }
    var parent = cfgEl.parentElement;
    if (!parent) return null;
    return parent.querySelector('[data-artist-list]');
  }

  function discoverSections() {
    var configEls = document.querySelectorAll('[data-artist-availability-config]');
    var allHandles = [];
    var handleSeen = {};
    var collectionMeta = [];
    var sections = [];

    for (var c = 0; c < configEls.length; c++) {
      var cfgEl = configEls[c];
      var root = listRootForConfig(cfgEl);
      if (!root) continue;
      if (window.__artistListProcessedRoots.indexOf(root) >= 0) continue;

      var config;
      try {
        config = JSON.parse(cfgEl.textContent);
      } catch (e) {
        continue;
      }

      var handles = config.collectionHandles || [];
      for (var h = 0; h < handles.length; h++) {
        var hh = handles[h];
        if (!hh || handleSeen[hh]) continue;
        handleSeen[hh] = true;
        allHandles.push(hh);
      }

      var meta = config.collectionMeta || [];
      for (var m = 0; m < meta.length; m++) {
        collectionMeta.push(meta[m]);
      }

      window.__artistListProcessedRoots.push(root);
      sections.push({ root: root, artists: config.artists || [] });
    }

    return { sections: sections, allHandles: allHandles, collectionMeta: collectionMeta };
  }

  function run() {
    var discovered = discoverSections();
    var sections = discovered.sections;
    var allHandles = discovered.allHandles;
    var collectionMeta = discovered.collectionMeta;

    if (!sections.length) return;

    if (window.__artistListCachedMerged) {
      applyAllSections(sections, window.__artistListCachedMerged);
      return;
    }

    if (!allHandles.length) return;

    var routesRoot = '/';
    if (typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root) {
      routesRoot = window.Shopify.routes.root;
    }
    if (routesRoot.charAt(routesRoot.length - 1) !== '/') {
      routesRoot += '/';
    }

    function parseLinkNext(linkHeader) {
      if (!linkHeader || typeof linkHeader !== 'string') return null;
      var parts = linkHeader.split(',');
      for (var i = 0; i < parts.length; i++) {
        var segment = parts[i].trim();
        if (!/rel=["']?next["']?/i.test(segment)) continue;
        var match = segment.match(/<([^>]+)>/);
        if (match) return match[1];
      }
      return null;
    }

    function resolveUrl(href) {
      if (!href) return null;
      if (href.indexOf('http') === 0) return href;
      if (href.indexOf('//') === 0) return window.location.protocol + href;
      var path = href.charAt(0) === '/' ? href : '/' + href;
      return window.location.origin + path;
    }

    function fetchAllProducts(handle) {
      var out = [];
      var seen = {};
      var limit = 250;
      var pagesLoaded = 0;
      var maxRequests = 250;
      var requestCount = 0;

      var nextUrl =
        routesRoot +
        'collections/' +
        encodeURIComponent(handle) +
        '/products.json?limit=' +
        limit +
        '&page=1';

      function done() {
        return { products: out, pagesLoaded: pagesLoaded, handle: handle };
      }

      function next() {
        if (requestCount >= maxRequests) return Promise.resolve(done());
        requestCount += 1;
        return fetch(nextUrl, { credentials: 'same-origin' })
          .then(function (res) {
            if (!res.ok) return null;
            var linkHeader = res.headers.get('Link');
            return res.json().then(function (data) {
              return { data: data, linkHeader: linkHeader };
            });
          })
          .then(function (wrapped) {
            if (!wrapped || !wrapped.data) return done();
            var products = wrapped.data.products || [];
            if (!products.length) return done();
            pagesLoaded += 1;
            var added = 0;
            for (var i = 0; i < products.length; i++) {
              var p = products[i];
              var id = p.id;
              if (seen[id]) continue;
              seen[id] = true;
              out.push(p);
              added++;
            }
            if (added === 0) return done();

            var linkNext = parseLinkNext(wrapped.linkHeader);
            if (linkNext) {
              nextUrl = resolveUrl(linkNext);
              return next();
            }
            if (products.length < limit) return done();
            var lastId = products[products.length - 1].id;
            nextUrl =
              routesRoot +
              'collections/' +
              encodeURIComponent(handle) +
              '/products.json?limit=' +
              limit +
              '&since_id=' +
              lastId;
            return next();
          })
          .catch(function () {
            return done();
          });
      }

      return next();
    }

    Promise.all(allHandles.map(fetchAllProducts))
      .then(function (results) {
        var seen = {};
        var merged = [];
        for (var g = 0; g < results.length; g++) {
          var group = (results[g] && results[g].products) || [];
          for (var i = 0; i < group.length; i++) {
            var p = group[i];
            var id = p.id;
            if (seen[id]) continue;
            seen[id] = true;
            merged.push(p);
          }
        }

        window.__artistListCachedMerged = merged;
        applyAllSections(sections, merged);
      })
      .catch(function () {});
  }

  function productIsAvailable(product) {
    if (!product) return false;
    if (product.available === true) return true;
    if (product.available === false) return false;
    var variants = product.variants || [];
    for (var v = 0; v < variants.length; v++) {
      if (variants[v].available) return true;
    }
    return false;
  }

  function productMatchesTag(product, tag) {
    if (!tag || !product) return false;
    var want = String(tag).trim();
    var tags = product.tags;
    if (typeof tags === 'string') {
      var parts = tags.split(',');
      for (var s = 0; s < parts.length; s++) {
        if (parts[s].trim() === want) return true;
      }
      return false;
    }
    if (!tags || !tags.length) return false;
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).trim() === want) return true;
    }
    return false;
  }

  function productFeaturedSrc(product) {
    if (!product) return '';
    var fi = product.featured_image;
    if (fi) {
      if (typeof fi === 'string') return fi;
      if (fi.src) return fi.src;
    }
    var im = product.image;
    if (im) {
      if (typeof im === 'string') return im;
      if (im.src) return im.src;
    }
    var list = product.images;
    if (list && list.length) {
      var z = list[0];
      if (typeof z === 'string') return z;
      if (z && z.src) return z.src;
    }
    return '';
  }

  function withImageWidth(src, w) {
    if (!src || typeof src !== 'string') return '';
    var sep = src.indexOf('?') >= 0 ? '&' : '?';
    return src + sep + 'width=' + w;
  }

  function applyInStockProductThumbnail(card, product) {
    var src = productFeaturedSrc(product);
    if (!src) return;
    var imgEl = card.querySelector('[data-artist-auto-thumb]');
    if (!imgEl) return;
    var displayW = 900;
    var sized = withImageWidth(src, displayW);
    imgEl.removeAttribute('srcset');
    imgEl.removeAttribute('sizes');
    imgEl.src = sized;
    var iw = product.image && product.image.width;
    var ih = product.image && product.image.height;
    if (iw && ih) {
      imgEl.width = iw;
      imgEl.height = ih;
    } else {
      imgEl.width = displayW;
      imgEl.height = displayW;
    }
  }

  function applyAllSections(sections, merged) {
    for (var s = 0; s < sections.length; s++) {
      var root = sections[s].root;
      var artists = sections[s].artists;

      for (var a = 0; a < artists.length; a++) {
        var artist = artists[a];
        var tag = artist.tag;
        if (!tag) continue;

        var matchProduct = null;
        for (var j = 0; j < merged.length; j++) {
          var pr = merged[j];
          if (productIsAvailable(pr) && productMatchesTag(pr, tag)) {
            matchProduct = pr;
            break;
          }
        }
        if (!matchProduct) continue;

        var idx = artist.index != null ? String(artist.index) : '';
        var card = root.querySelector('[data-artist-index="' + idx + '"]');
        if (!card) continue;
        card.classList.add('dark-mode');

        var link = card.querySelector('a[artist_name]');
        if (link) link.setAttribute('instock', 'in-stock');
        applyInStockProductThumbnail(card, matchProduct);
      }
    }

    refreshArtistListMenu();
  }

  function refreshArtistListMenu() {
    var list = document.querySelector('[artist_list]');
    if (!list) return;
    list.innerHTML = '';
    var allArtist = document.querySelectorAll('[artist_name]');
    allArtist.forEach(function (target) {
      var has_available = target.getAttribute('instock') || '';
      var first_letter = target.innerHTML.toLowerCase().slice(0, 1);
      var html =
        '<li class="py-md-2 py-1 col-md-4 col-6 px-3 ' +
        has_available +
        '"><a href="' +
        (target.getAttribute('href') || '') +
        '" class="py-1 text-uppercase font-size-xs text-black">' +
        target.innerHTML +
        '</a></li>';
      list.insertAdjacentHTML('beforeend', html);
      var artist_letter = document.querySelector('[artist_latter="' + first_letter + '"]');
      if (!artist_letter) return;
      var a = artist_letter.querySelector('a');
      if (!a) return;
      a.classList.add('fw-bold');
      var click_ev = a.getAttribute('onclick');
      if (click_ev) {
        a.setAttribute('onclick', click_ev.split("'no'").join("'" + first_letter + "'"));
      }
    });
  }

  run();
})();